import React, { PureComponent } from 'react';

import ReadMore from './component';

const isOverflowing = (element) => element.scrollHeight > element.clientHeight;

/**
 * Read More container component.
 * Injects content with state to control collapsed view, checking for overflowing content.
 * Able to specify number of lines to show for overflowed text.
 */
class ReadMoreContainer extends PureComponent {
  state = {
    // Assume that if the component is being used, "long" content is being provided
    collapsed: true,
    isOverflowing: true,
  };

  componentDidMount() {
    if (this.element) {
      // Although given the above assumption, it's posssible that the content is not overflowing
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ isOverflowing: isOverflowing(this.element) });
    }
  }

  toggleCollapse = () => {
    this.setState((state) => ({ collapsed: !state.collapsed }));
  };

  render() {
    const { onExpand } = this.props;
    return (
      <ReadMore
        onClick={(...args) => {
          if (onExpand) onExpand(...args);
          this.toggleCollapse(...args);
        }}
        onRef={(element) => {
          this.element = element;
        }}
        {...this.props}
        {...this.state}
      />
    );
  }
}

export default ReadMoreContainer;
